import { render } from "./LeadsNumByUser.vue?vue&type=template&id=0013914c"
import script from "./LeadsNumByUser.vue?vue&type=script&lang=js"
export * from "./LeadsNumByUser.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__